/* gm-b2b 20261013 merch-qo-form */
/* gm-b2b 20261013 wholesale-preorder-qo-extra */
/* ================================================================
   GAYNOR MINDEN B2B WHOLESALE PORTAL
   Theme JavaScript — wired to Shopify Cart AJAX API
   ================================================================ */

'use strict';

// ── Product variant IDs (base variants for each model) ──────────
const GM_PRODUCTS = {
  europa:      { id: 10654663672118, variantId: 53875809812790, skuPrefix: 'E' },
  lyra:        { id: 10654663704886, variantId: 53875809845558, skuPrefix: 'L' },
  renaissance: { id: 10654663770422, variantId: 53875809911094, skuPrefix: 'REN' },
  primavera:   { id: 10654663835958, variantId: 53875810009398, skuPrefix: 'PRI' },
};

// ── State ────────────────────────────────────────────────────────
let activeRowIndex = null;
let cartData      = null;

// ── Init ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initCart();
  initCartDrawer();
  fetchProductPrices();
});

// ── SHOPIFY CART API ─────────────────────────────────────────────
async function fetchCart() {
  const resp = await fetch('/cart.js');
  cartData = await resp.json();
  return cartData;
}

async function addToCart(variantId, quantity, properties) {
  const resp = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity, properties })
  });
  if (!resp.ok) {
    const err = await resp.json();
    throw new Error(err.description || 'Could not add to cart');
  }
  return resp.json();
}

let _cartOp = Promise.resolve();

function queueCartOp(fn) {
  _cartOp = _cartOp.then(fn, fn);
  return _cartOp;
}

/** qty 0 = remove. Prefer line-item key via /cart/update.js (change.js id= is flaky). */

function cartItemIsPackTights(item) {
  if (!item) return false;
  var h = String(item.handle || '').toLowerCase();
  var t = String(item.product_title || item.title || '').toLowerCase();
  var pt = String(item.product_type || '').toLowerCase();
  if (h === 'sweater-tights' || t === 'sweater tights') return false;
  if (h === 'tights-socks-20-pack' || h.indexOf('tights-socks') !== -1) return false;
  if (pt.indexOf('tight') !== -1) return true;
  if (h.indexOf('tight') !== -1) return true;
  if (/\btights?\b/.test(t)) return true;
  return false;
}

/** Map a requested cart qty onto 3/6/9… (0 = remove). Liquid buttons send cur±1. */
function snapCartPackQty(current, requested) {
  var cur = parseInt(current, 10);
  var qty = parseInt(requested, 10);
  if (Number.isNaN(qty) || qty <= 0) return 0;
  if (Number.isNaN(cur) || cur < 0) cur = 0;
  if (qty === cur + 1) {
    if (cur % 3 === 0 && cur >= 3) return cur + 3;
    return Math.max(3, Math.ceil(cur / 3) * 3);
  }
  if (qty === cur - 1) {
    if (cur <= 3) return 0;
    if (cur % 3 === 0) return cur - 3;
    var down = Math.floor(cur / 3) * 3;
    return down < 3 ? 0 : down;
  }
  if (qty % 3 === 0 && qty >= 3) return qty;
  if (qty < 3) return 3;
  return Math.max(3, Math.round(qty / 3) * 3);
}

function findCartItem(lineOrKey) {
  if (!cartData || !cartData.items) return null;
  var asStr = String(lineOrKey == null ? '' : lineOrKey);
  for (var i = 0; i < cartData.items.length; i++) {
    var it = cartData.items[i];
    if (String(it.key || '') === asStr) return it;
    if (String(i + 1) === asStr) return it;
  }
  return null;
}

async function updateCartLine(lineOrKey, quantity) {
  let qty = parseInt(quantity, 10);
  if (Number.isNaN(qty) || qty < 0) return;
  const asStr = String(lineOrKey == null ? '' : lineOrKey);
  const packItem = findCartItem(asStr);
  if (packItem && cartItemIsPackTights(packItem)) {
    qty = snapCartPackQty(packItem.quantity, qty);
  }
  const useKey = asStr.length > 3 && !/^\d{1,3}$/.test(asStr);
  return queueCartOp(async function () {
    let resp;
    if (useKey) {
      const updates = {};
      updates[asStr] = qty;
      resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } else {
      resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(asStr, 10), quantity: qty })
      });
    }
    if (!resp.ok) {
      let msg = 'Could not update cart';
      try { const err = await resp.json(); msg = err.description || err.message || msg; } catch (e) {}
      console.warn('cart update failed', msg, asStr, qty);
    }
    await gmRefreshCartDrawer(false);
    document.body.classList.add('drawer-open');
  });
}

window.updateCartItem = updateCartLine;

// ── PRICES (fetch B2B catalog prices from Shopify) ───────────────
async function fetchProductPrices() {
  for (const [model, product] of Object.entries(GM_PRODUCTS)) {
    try {
      const resp = await fetch(`/products/${getProductHandle(model)}.js`);
      const data = await resp.json();
      const variant = data.variants.find(v => v.id === product.variantId) || data.variants[0];
      if (variant) {
        const price = formatMoney(variant.price);
        GM_PRODUCTS[model].price     = variant.price;
        GM_PRODUCTS[model].priceFormatted = price;
      }
    } catch(e) {
      console.warn(`Could not fetch price for ${model}:`, e);
    }
  }
  if (typeof window.paintModalUnitPrice === 'function') window.paintModalUnitPrice();
}

window.paintModalUnitPrice = function() {
  var el = document.getElementById('modal-unit-price');
  var tab = document.querySelector('.model-tab.is-active');
  if (!el || !tab) return;
  var model = tab.getAttribute('data-model');
  var p = GM_PRODUCTS[model];
  if (p && p.priceFormatted) { el.textContent = p.priceFormatted; return; }
  var map = { europa: 'ECL', lyra: 'LCL', renaissance: 'REN', primavera: 'PRI' };
  var pfx = map[model];
  var cents = pfx && window.GM_POINTE_PREFIX_PRICE && window.GM_POINTE_PREFIX_PRICE[pfx];
  if (cents != null) el.textContent = formatMoney(cents);
  else el.textContent = '\u2014';
}

function getProductHandle(model) {
  const handles = {
    europa:      'europa-classic-medium-pointe',
    lyra:        'lyra-classic-medium-pointe',
    renaissance: 'renaissance-pointe-shoes',
    primavera:   'primavera-pointe-shoes',
  };
  return handles[model] || model;
}

/** Active presentment currency: cart.js first, then Liquid inject, else USD. */
function gmCurrencyCode() {
  if (cartData && cartData.currency) return String(cartData.currency).toUpperCase();
  if (typeof window !== 'undefined' && window.GM_B2B_CURRENCY) {
    return String(window.GM_B2B_CURRENCY).toUpperCase();
  }
  return 'USD';
}

function formatMoney(cents, currencyCode) {
  const code = (currencyCode || gmCurrencyCode() || 'USD').toUpperCase();
  const n = (Number(cents) || 0) / 100;
  const amt = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  switch (code) {
    case 'EUR': return '€' + amt;
    case 'GBP': return '£' + amt;
    case 'CAD': return 'CA$' + amt;
    case 'AUD': return 'A$' + amt;
    default: return '$' + amt;
  }
}

// ── CART INIT ────────────────────────────────────────────────────
async function initCart() {
  await fetchCart();
  renderCartDrawer();
}

function paintLongFormTabCounts() {
  var prefixes = {
    europa: /^E[A-Z]{2}-/,
    lyra: /^L[A-Z]{2}-/,
    renaissance: /^REN-/,
    primavera: /^PRI-/
  };
  var items = (cartData && cartData.items) || [];
  Object.keys(prefixes).forEach(function (model) {
    var el = document.getElementById('count-' + model);
    if (!el) return;
    var re = prefixes[model];
    var total = 0;
    items.forEach(function (i) {
      var props = i.properties || {};
      var s = props._sku || props['_sku'] || '';
      if (re.test(s)) total += parseInt(i.quantity, 10) || 0;
    });
    el.textContent = String(total);
  });
}

function formatCartMoney(cents) {
  // Shopify cart.js amounts are in presentment-currency minor units
  return formatMoney(cents, cartData && cartData.currency);
}

/**
 * Full drawer rebuild from cartData (/cart.js shape).
 * Header badge was updating on add, but #cart-body stayed as Liquid empty-state
 * from page load — that's why drawer showed 0 items while header showed 1 @ $34.
 */
function renderCartDrawer() {
  if (!cartData) return;
  paintLongFormTabCounts();
  const count = cartData.item_count || 0;
  const total = formatCartMoney(cartData.total_price);

  const badge = document.getElementById('cart-count-badge');
  const totalEl = document.getElementById('cart-total-header');
  if (badge) badge.textContent = count;
  if (totalEl) totalEl.textContent = total;

  const countLabel = document.getElementById('cart-item-count-label');
  if (countLabel) countLabel.textContent = `${count} item${count !== 1 ? 's' : ''}`;

  const subtotal = document.getElementById('cart-subtotal');
  if (subtotal) subtotal.textContent = total;

  const body = document.getElementById('cart-body');
  if (!body) return;

  if (count === 0 || !cartData.items || !cartData.items.length) {
    body.innerHTML =
      '<div class="cart-empty-state" id="cart-empty">' +
        '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="opacity:0.3" aria-hidden="true">' +
          '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
          '<line x1="3" y1="6" x2="21" y2="6"/>' +
          '<path d="M16 10a4 4 0 01-8 0"/>' +
        '</svg>' +
        '<span>Your order is empty</span>' +
      '</div>';
    return;
  }

  let html = '<div id="cart-items-list">';
  cartData.items.forEach(function (item, idx) {
    const lineNum = idx + 1;
    const linePrice = formatCartMoney(item.line_price);
    const props = item.properties || {};
    const skuProp = props['_sku'] || props._sku || '';
    const metaParts = [];
    Object.keys(props).forEach(function (k) {
      if (k && k.charAt(0) !== '_') metaParts.push(k + ': ' + props[k]);
    });
    // Variant title as secondary meta when no custom props
    if (!metaParts.length && item.variant_title && item.variant_title !== 'Default Title') {
      metaParts.push(item.variant_title);
    }
    const key = item.key || '';
    const pack = cartItemIsPackTights(item);
    const packStep = pack ? 3 : 1;
    const packMin = pack ? 3 : 1;
    html +=
      '<div class="cart-line-item" data-line="' + lineNum + '" data-key="' + escapeHtml(key) + '" data-pack-step="' + packStep + '">' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + escapeHtml(item.product_title || item.title || 'Item') + '</div>' +
          (metaParts.length ? '<div class="cart-item-meta">' + escapeHtml(metaParts.join(' · ')) + '</div>' : '') +
          (skuProp ? '<div class="cart-item-sku">' + escapeHtml(skuProp) + '</div>' : '') +
        '</div>' +
        '<div class="cart-item-right">' +
          '<div class="cart-item-price">' + linePrice + '</div>' +
          '<div class="cart-qty-control" aria-label="Adjust quantity">' +
            '<button type="button" data-cart-act="dec" aria-label="Decrease">−</button>' +
            '<input type="number" class="qty-val" value="' + item.quantity + '" min="' + packMin + '" step="' + packStep + '" data-cart-act="qty" aria-label="Quantity">' +
            '<button type="button" data-cart-act="inc" aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="btn btn-ghost btn-xs" style="color:var(--charcoal-muted);font-size:11px" data-cart-act="remove">Remove</button>' +
        '</div>' +
      '</div>';
  });
  html += '</div>';
  body.innerHTML = html;
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Fetch /cart.js + rebuild drawer DOM. Internal name — do not alias to window.refreshCartDrawer (classic-script global = infinite recurse). */
async function gmRefreshCartDrawer(openAfter) {
  await fetchCart();
  renderCartDrawer();
  if (openAfter) openCart();
}

window.gmRefreshCartDrawer = gmRefreshCartDrawer;
window.refreshCartDrawer = function (openAfter) {
  return gmRefreshCartDrawer(!!openAfter);
};

// ── CART DRAWER ──────────────────────────────────────────────────
function initCartDrawer() {
  const openBtn  = document.getElementById('btn-open-cart');
  const closeBtn = document.getElementById('btn-close-cart');
  const overlay  = document.getElementById('drawer-overlay');

  if (openBtn) {
    openBtn.addEventListener('click', async () => {
      // Always re-sync from cart before open so badge/drawer never diverge
      try {
        await fetchCart();
        renderCartDrawer();
      } catch (e) {
        console.warn('Cart refresh before open failed', e);
      }
      openCart();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay)  overlay.addEventListener('click', closeCart);

  const checkoutBtn = document.getElementById('btn-b2b-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Unpublished theme preview cannot host native checkout — leave preview and go.
      window.location.assign('/checkout');
    });
  }
  const emptyBtn = document.getElementById('btn-b2b-empty-cart');
  if (emptyBtn) {
    emptyBtn.addEventListener('click', function () {
      queueCartOp(async function () {
        await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        await gmRefreshCartDrawer(false);
      });
    });
  }

  const body = document.getElementById('cart-body');
  if (body && !body.dataset.gmCartBound) {
    body.dataset.gmCartBound = '1';
    body.addEventListener('click', function (e) {
      const actEl = e.target.closest('[data-cart-act]');
      if (!actEl || !body.contains(actEl)) return;
      const row = actEl.closest('.cart-line-item');
      if (!row) return;
      const key = row.getAttribute('data-key') || row.getAttribute('data-line');
      const qtyEl = row.querySelector('.qty-val');
      const cur = parseInt(qtyEl && qtyEl.value, 10) || 1;
      const act = actEl.getAttribute('data-cart-act');
      const step = parseInt(row.getAttribute('data-pack-step') || '1', 10) || 1;
      e.preventDefault();
      if (act === 'remove') updateCartLine(key, 0);
      else if (act === 'dec') {
        var nextDec = cur - step;
        if (step === 3 && nextDec < 3) nextDec = 0;
        updateCartLine(key, Math.max(0, nextDec));
      } else if (act === 'inc') {
        var nextInc = (step === 3 && cur % 3 !== 0) ? Math.ceil(cur / 3) * 3 : cur + step;
        updateCartLine(key, nextInc);
      }
    });
    body.addEventListener('change', function (e) {
      const actEl = e.target.closest('[data-cart-act="qty"]');
      if (!actEl) return;
      const row = actEl.closest('.cart-line-item');
      if (!row) return;
      const key = row.getAttribute('data-key') || row.getAttribute('data-line');
      updateCartLine(key, actEl.value);
    });
  }
}

function openCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('drawer-overlay');
  drawer?.classList.add('is-open');
  overlay?.classList.add('is-open');
  document.documentElement.classList.add('drawer-open');
  document.body.classList.add('drawer-open');
  document.body.style.overflow = 'hidden';
  if (drawer) {
    // eslint-disable-next-line no-unused-expressions
    drawer.offsetWidth;
    drawer.style.transform = 'translate3d(0,0,0)';
  }
}

function closeCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('drawer-overlay');
  drawer?.classList.remove('is-open');
  overlay?.classList.remove('is-open');
  document.documentElement.classList.remove('drawer-open');
  document.body.classList.remove('drawer-open');
  document.body.style.overflow = '';
  if (drawer) drawer.style.transform = '';
}

// Re-assert open position on resize (fixes partial cutoff after window width changes)
window.addEventListener('resize', () => {
  const drawer = document.getElementById('cart-drawer');
  if (drawer?.classList.contains('is-open')) {
    drawer.style.transform = 'translate3d(0,0,0)';
  }
});

// ── QUICK ORDER: DYNAMIC CATEGORY HANDLING ───────────────────────
// Fetches real products from Shopify collections — auto-updates when
// products are added/removed from collections. Zero maintenance.

const _collectionCache = {};
const _rowData = {};

// Product detail cache (keyed by handle) — stores full .js data with inventory
const _productDetailCache = {};

function mergeQoExtra(handle, products) {
  var extra = (window.GM_QO_EXTRA && window.GM_QO_EXTRA[handle]) || [];
  extra.forEach(function(p) {
    if (!products.some(function(x) { return String(x.handle) === String(p.handle); })) {
      products.push(p);
    }
  });
  return products;
}

function mapQoJsProduct(p) {
  window.GM_INVENTORY = window.GM_INVENTORY || {};
  window.GM_PRICES = window.GM_PRICES || {};
  var variants = (p.variants || []).map(function(v) {
    if (v.id != null) {
      if (v.inventory_quantity != null) window.GM_INVENTORY[String(v.id)] = v.inventory_quantity;
      window.GM_PRICES[String(v.id)] = v.price;
    }
    return {
      id: v.id,
      title: v.title,
      option1: v.option1,
      option2: v.option2,
      option3: v.option3,
      price: v.price,
      available: v.available,
      inventory_quantity: v.inventory_quantity,
      inventory_management: v.inventory_management
    };
  });
  return { id: p.id, title: p.title, handle: p.handle, variants: variants };
}

function ensureQoExtras() {
  if (window.__gmQoExtrasReady) return window.__gmQoExtrasReady;
  var specs = window.GM_QO_EXTRA_SPECS || [];
  window.GM_QO_EXTRA = window.GM_QO_EXTRA || {};
  var invUrl = window.GM_QO_EXTRA_INV_URL;
  var invP = invUrl ? fetch(invUrl).then(function(r) { return r.ok ? r.json() : {}; }).catch(function() { return {}; }) : Promise.resolve({});
  var prodP = Promise.all(specs.map(function(s) {
    if (!s || !s.handle || !s.col) return Promise.resolve();
    return fetch('/products/' + s.handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.handle) return;
        if (!window.GM_QO_EXTRA[s.col]) window.GM_QO_EXTRA[s.col] = [];
        var mapped = mapQoJsProduct(p);
        if (!window.GM_QO_EXTRA[s.col].some(function(x) { return String(x.handle) === String(mapped.handle); })) {
          window.GM_QO_EXTRA[s.col].push(mapped);
        }
      })
      .catch(function() {});
  }));
  window.__gmQoExtrasReady = Promise.all([invP, prodP]).then(function(res) {
    var extraInv = res[0] || {};
    window.GM_INVENTORY = window.GM_INVENTORY || {};
    var wh = window.GM_B2B_WH === 'n' ? 'n' : 'm';
    function extraQty(row) {
      if (row && typeof row === 'object' && !Array.isArray(row) && (row.m != null || row.n != null)) {
        var q = row[wh];
        return q == null ? 0 : q;
      }
      return row;
    }
    Object.keys(extraInv).forEach(function(id) {
      var q = extraQty(extraInv[id]);
      if (q != null) window.GM_INVENTORY[String(id)] = q;
    });
    Object.keys(window.GM_QO_EXTRA).forEach(function(col) {
      (window.GM_QO_EXTRA[col] || []).forEach(function(p) {
        (p.variants || []).forEach(function(v) {
          var q = extraQty(extraInv[String(v.id)]);
          if (q != null) v.inventory_quantity = q;
        });
      });
    });
  });
  return window.__gmQoExtrasReady;
}

function fetchCollectionProducts(handle) {
  if (_collectionCache[handle]) return Promise.resolve(_collectionCache[handle]);
  return ensureQoExtras().then(function() {
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).map(function(p) {
          return {
            id: p.id,
            title: p.title,
            handle: p.handle,
            variants: p.variants.map(function(v) {
              return {
                id: v.id,
                title: v.title,
                option1: v.option1,
                option2: v.option2,
                option3: v.option3,
                price: v.price,
                available: v.available,
                inventory_quantity: v.inventory_quantity,
                inventory_management: v.inventory_management
              };
            })
          };
        });
        products = mergeQoExtra(handle, products);
        _collectionCache[handle] = products;
        return products;
      })
      .catch(function() {
        var products = mergeQoExtra(handle, []);
        _collectionCache[handle] = products;
        return products;
      });
  });
}

// Fetch full product detail (with guaranteed inventory data) via .js endpoint
function fetchProductDetail(handle) {
  if (_productDetailCache[handle]) return Promise.resolve(_productDetailCache[handle]);
  return fetch('/products/' + handle + '.js')
    .then(r => r.json())
    .then(data => {
      _productDetailCache[handle] = data;
      return data;
    });
}

// ── Traffic light inventory indicator ─────────────────────────────
// Red = out of stock (0), Yellow = low (<5), Green = in stock (5+)
function stockDot(qty) {
  if (qty === null || qty === undefined) return '<span class="stock-dot stock-unknown" title="Inventory not available"></span>';
  if (qty <= 0)  return '<span class="stock-dot stock-red" title="Out of stock (0)"></span>';
  if (qty < 5)   return '<span class="stock-dot stock-yellow" title="Low stock (' + qty + ')"></span>';
  return '<span class="stock-dot stock-green" title="In stock (' + qty + ')"></span>';
}

function stockLabel(qty) {
  if (qty === null || qty === undefined) return '';
  if (qty <= 0) return '<span class="stock-label">Not in Stock</span>';
  if (qty < 5)  return '<span class="stock-label">Low Stock</span>';
  return '<span class="stock-label">Well-Stocked</span>';
}

window.clearQoLinePrice = function(rowIndex) {
  var el = document.getElementById('qo-price-' + rowIndex);
  if (el) el.textContent = '\u2014';
};

window.showQoLinePrice = function(rowIndex, variantId, sku) {
  var el = document.getElementById('qo-price-' + rowIndex);
  if (!el) return;
  var cents = null;
  if (variantId != null && window.GM_PRICES && window.GM_PRICES[String(variantId)] != null) {
    cents = window.GM_PRICES[String(variantId)];
  }
  if (cents == null && sku && window.GM_POINTE_PREFIX_PRICE) {
    var m = String(sku).toUpperCase().match(/^(ECL|ESC|ESK|LCL|LSC|LSK|PRI|REN)/);
    if (m && window.GM_POINTE_PREFIX_PRICE[m[1]] != null) cents = window.GM_POINTE_PREFIX_PRICE[m[1]];
  }
  if (cents == null) { el.textContent = '\u2014'; return; }
  el.textContent = formatMoney(cents);
};

function showStockIndicator(rowIndex, variant) {
  // Remove any existing indicator
  var existing = document.getElementById('qo-stock-' + rowIndex);
  if (existing) existing.remove();

  if (!variant) return;

  var qty = variant.inventory_quantity;
  var indicator = document.createElement('span');
  indicator.id = 'qo-stock-' + rowIndex;
  indicator.className = 'stock-indicator';
  indicator.innerHTML = stockDot(qty) + stockLabel(qty);

  var container = document.getElementById('qo-opts-' + rowIndex);
  if (container) {
    container.appendChild(indicator);
  } else {
    var configCell = document.getElementById('qo-config-' + rowIndex);
    if (configCell) configCell.appendChild(indicator);
  }
}

window.handleCategoryChange = function(select, rowIndex) {
  const val = (typeof select === 'string') ? select : (select && select.value);
  const tr = document.querySelector('tr[data-row="' + rowIndex + '"]');
  const configCell = document.getElementById('qo-config-' + rowIndex);
  const btnCell = tr ? tr.querySelector('td:last-child') : null;
  if (!configCell) return;

  delete _rowData[rowIndex];
  if (typeof window.clearQoLinePrice === 'function') window.clearQoLinePrice(rowIndex);

  if (val === 'pointe') {
    configCell.innerHTML =
      '<span class="qo-config-badge" id="qo-badge-' + rowIndex + '" style="gap:6px">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2"/></svg>' +
        ' Not configured' +
      '</span>' +
      '<button type="button" class="btn btn-outline btn-sm" onclick="openPointeModal(' + rowIndex + ')">Configure</button>';
    if (btnCell) btnCell.innerHTML = '<button type="button" class="btn btn-primary btn-sm" onclick="addPointeToCart(' + rowIndex + ')">Add</button>';
    return;
  }

  var collectionMap = { leotards:'leotards', tights:'tights', warmers:'warmers', accessories:'accessories', liberty:'technique-slippers', 'tutus-skirts':'tutus-skirts', 'pointe-essentials':'pointe-essentials', 'go-beyond-the-barre':'go-beyond-the-barre', 'dance-bags':'dance-bags', jewelry:'jewelry', merchandising:'merchandising' };
  var collection = collectionMap[val];
  if (!collection) return;

  configCell.innerHTML = '<span class="qo-config-badge" style="color:var(--charcoal-muted)">Loading\u2026</span>';
  if (btnCell) btnCell.innerHTML = '<button class="btn btn-primary btn-sm" disabled>Add</button>';

  fetchCollectionProducts(collection).then(function(products) {
    var html = '<select class="qo-select qo-select-product" aria-label="Product" onchange="handleProductSelect(this,' + rowIndex + ')">';
    html += '<option value="">Select product</option>';
    products.forEach(function(p, i) {
      html += '<option value="' + i + '">' + p.title + '</option>';
    });
    html += '</select>';
    html += '<span id="qo-opts-' + rowIndex + '" class="qo-opts"></span>';
    configCell.innerHTML = html;
    _rowData[rowIndex] = { products: products, variantId: null };
    if (btnCell) btnCell.innerHTML = '<button class="btn btn-primary btn-sm" onclick="addQuickOrderItem(' + rowIndex + ')">Add</button>';
    if (products.length === 1) {
      var prodSel = configCell.querySelector('select');
      if (prodSel) {
        prodSel.value = '0';
        window.handleProductSelect(prodSel, rowIndex);
      }
    }
    window.applyQoTightsQty(rowIndex);
  }).catch(function(e) {
    configCell.innerHTML = '<span class="qo-config-badge" style="color:var(--amber)">Could not load products</span>';
    console.warn('Collection fetch failed:', e);
  });
};

window.handleProductSelect = function(select, rowIndex) {
  var optsContainer = document.getElementById('qo-opts-' + rowIndex);
  if (!optsContainer || !_rowData[rowIndex]) return;

  var idx = parseInt(select.value, 10);
  if (isNaN(idx)) { optsContainer.innerHTML = ''; _rowData[rowIndex].variantId = null; _rowData[rowIndex].selectedProduct = null; window.clearQoLinePrice(rowIndex); window.applyQoTightsQty(rowIndex); return; }

  var product = _rowData[rowIndex].products[idx];
  if (!product) return;

  _rowData[rowIndex].selectedProduct = product;
  window.applyQoTightsQty(rowIndex);

  // If only one variant (Default Title), auto-select it and show stock
  if (product.variants.length === 1) {
    optsContainer.innerHTML = '';
    _rowData[rowIndex].variantId = product.variants[0].id;
    var inv = window.GM_INVENTORY || {};
    var qty = inv[String(product.variants[0].id)];
    showStockIndicator(rowIndex, { inventory_quantity: qty !== undefined ? qty : null });
    window.showQoLinePrice(rowIndex, product.variants[0].id);
    return;
  }

  // Extract unique option values
  var opt1Vals = [], opt2Vals = [], opt3Vals = [];
  var seen1 = {}, seen2 = {}, seen3 = {};
  product.variants.forEach(function(v) {
    if (v.option1 && !seen1[v.option1]) { opt1Vals.push(v.option1); seen1[v.option1] = true; }
    if (v.option2 && !seen2[v.option2]) { opt2Vals.push(v.option2); seen2[v.option2] = true; }
    if (v.option3 && !seen3[v.option3]) { opt3Vals.push(v.option3); seen3[v.option3] = true; }
  });

  var html = '';
  if (opt1Vals.length > 0) {
    var label1 = guessOptionLabel(opt1Vals);
    html += '<select class="qo-select qo-opt qo-select-opt" aria-label="' + label1 + '" data-opt="1" onchange="resolveVariant(' + rowIndex + ')">';
    html += '<option value="">' + label1 + '</option>';
    opt1Vals.forEach(function(v) { html += '<option value="' + v + '">' + v + '</option>'; });
    html += '</select>';
  }
  if (opt2Vals.length > 0) {
    var label2 = guessOptionLabel(opt2Vals);
    html += '<select class="qo-select qo-opt qo-select-opt" aria-label="' + label2 + '" data-opt="2" onchange="resolveVariant(' + rowIndex + ')">';
    html += '<option value="">' + label2 + '</option>';
    opt2Vals.forEach(function(v) { html += '<option value="' + v + '">' + v + '</option>'; });
    html += '</select>';
  }
  if (opt3Vals.length > 0) {
    var label3 = guessOptionLabel(opt3Vals);
    html += '<select class="qo-select qo-opt qo-select-opt" aria-label="' + label3 + '" data-opt="3" onchange="resolveVariant(' + rowIndex + ')">';
    html += '<option value="">' + label3 + '</option>';
    opt3Vals.forEach(function(v) { html += '<option value="' + v + '">' + v + '</option>'; });
    html += '</select>';
  }

  optsContainer.innerHTML = html;
  _rowData[rowIndex].variantId = null;
};

function guessOptionLabel(values) {
  var sizes = ['P','S','M','L','XL','XS','J','P/S','M/L','OS','2','3','4','5','3/3+','4/5'];
  var allSizes = values.every(function(v) { return sizes.indexOf(v) >= 0 || /^\d/.test(v); });
  if (allSizes) return 'Size';
  var colorish = ['Black','White','Pink','Navy','Red','Blue','Tan','Cappuccino','Espresso','Mocha','Midnight Blue'];
  var someColors = values.some(function(v) { return colorish.indexOf(v) >= 0 || v.indexOf('Pink') >= 0 || v.indexOf('Blue') >= 0 || v.indexOf('Rose') >= 0; });
  if (someColors) return 'Color';
  var shanks = ['Feather','Hard','Pianissimo','Supple','Extra-Flex'];
  if (values.every(function(v) { return shanks.indexOf(v) >= 0; })) return 'Shank';
  return 'Option';
}

window.resolveVariant = function(rowIndex) {
  var data = _rowData[rowIndex];
  if (!data || !data.selectedProduct) return;

  var container = document.getElementById('qo-opts-' + rowIndex);
  if (!container) return;

  var selects = container.querySelectorAll('select.qo-opt');
  var vals = {};
  selects.forEach(function(s) { vals[s.getAttribute('data-opt')] = s.value; });

  // Find matching variant — only when ALL available options are selected
  var allSelected = true;
  var optCount = document.querySelectorAll('#qo-opts-' + rowIndex + ' select.qo-opt').length;
  var filledCount = Object.values(vals).filter(function(v) { return v !== ''; }).length;
  if (filledCount < optCount) allSelected = false;

  var match = null;
  if (allSelected) {
    match = data.selectedProduct.variants.find(function(v) {
      return (!vals['1'] || v.option1 === vals['1'])
          && (!vals['2'] || v.option2 === vals['2'])
          && (!vals['3'] || v.option3 === vals['3']);
    });
  }

  data.variantId = match ? match.id : null;

  // Show traffic light stock indicator only when variant is fully resolved
  if (match) {
    var inv = window.GM_INVENTORY || {};
    var qty = inv[String(match.id)];
    showStockIndicator(rowIndex, { inventory_quantity: qty !== undefined ? qty : null });
    window.showQoLinePrice(rowIndex, match.id);
  } else {
    // Clear indicator when no valid variant selected
    var existingDot = document.getElementById('qo-stock-' + rowIndex);
    if (existingDot) existingDot.remove();
    window.clearQoLinePrice(rowIndex);
  }
};

window.addQuickOrderItem = function(rowIndex) {
  var data = _rowData[rowIndex];
  if (!data || !data.variantId) {
    alert('Please select a product and all options before adding.');
    return;
  }

  var qtyEl = document.getElementById('qo-qty-' + rowIndex);
  if (typeof window.qoSnapQty === 'function') window.qoSnapQty(rowIndex);
  var qty = parseInt(qtyEl ? qtyEl.value : '1', 10) || 1;

  var btn = document.querySelector('tr[data-row="' + rowIndex + '"] td:last-child button');
  if (btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }

  addToCart(data.variantId, qty, {})
    .then(function() {
      // Rebuild drawer line items (not just header badge) so open cart matches cart.js
      if (typeof window.refreshCartDrawer === 'function') {
        return window.refreshCartDrawer(false);
      }
      return fetchCart().then(function () { renderCartDrawer(); });
    })
    .then(function() {
      if (btn) {
        btn.textContent = '\u2713 Added';
        btn.style.background = '#1A1A1A';
        btn.style.color = '#FFFFFF';
        btn.disabled = false;
        btn.setAttribute('title', 'In this order — click to add another');
      }
    })
    .catch(function(err) {
      alert('Could not add to cart: ' + err.message);
      if (btn) { btn.textContent = 'Add'; btn.disabled = false; }
    });
};

// ── ADD ROW (quick order) ─────────────────────────────────────────
let rowCounter = 10;
function qoIsPackTights(rowIndex) {
  var cat = document.getElementById('qo-cat-' + rowIndex);
  if (!cat || cat.value !== 'tights') return false;
  var product = (_rowData[rowIndex] && _rowData[rowIndex].selectedProduct) || null;
  if (!product) return true;
  var h = String(product.handle || '').toLowerCase();
  var t = String(product.title || '').toLowerCase();
  if (h === 'sweater-tights' || t === 'sweater tights') return false;
  return true;
}
window.qoSnapQty = function(id) {
  var e = document.getElementById('qo-qty-' + id);
  if (!e || !qoIsPackTights(id)) return;
  var n = parseInt(e.value, 10);
  if (Number.isNaN(n) || n < 3) { e.value = '3'; return; }
  e.value = String(Math.max(3, Math.round(n / 3) * 3));
};

(function bindQoQtyDelegate() {
  if (document.documentElement.getAttribute('data-gm-qo-qty-delegate') === '1') return;
  document.documentElement.setAttribute('data-gm-qo-qty-delegate', '1');
  document.addEventListener('click', function(ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('.qo-form .cart-qty-control button');
    if (!btn) return;
    var tr = btn.closest('tr[data-row]');
    if (!tr) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    var id = tr.getAttribute('data-row');
    var label = (btn.getAttribute('aria-label') || btn.textContent || '').toLowerCase();
    var dir = (label.indexOf('decrease') !== -1 || label.indexOf('\u2212') !== -1 || label.trim() === '-') ? -1 : 1;
    window.qoQtyNudge(id, dir);
  }, true);
})();

window.qoQtyNudge = function(id, dir) {
  var e = document.getElementById('qo-qty-' + id);
  if (!e) return;
  var step = qoIsPackTights(id) ? 3 : 1;
  var min = step === 3 ? 3 : 1;
  var cur = parseInt(e.value, 10);
  if (Number.isNaN(cur)) cur = min;
  var next = cur + dir * step;
  if (next < min) next = min;
  e.value = String(next);
};
window.applyQoTightsQty = function(rowIndex) {
  var e = document.getElementById('qo-qty-' + rowIndex);
  if (!e) return;
  if (qoIsPackTights(rowIndex)) {
    e.min = '3';
    e.step = '3';
    e.setAttribute('data-qty-step', '3');
    var cur = parseInt(e.value, 10) || 0;
    if (cur < 3 || cur % 3 !== 0) e.value = '3';
    if (!e.getAttribute('data-pack-bound')) {
      e.setAttribute('data-pack-bound', '1');
      e.addEventListener('change', function() { window.qoSnapQty(rowIndex); });
      e.addEventListener('blur', function() { window.qoSnapQty(rowIndex); });
    }
  } else {
    var leavingPack = e.getAttribute('data-qty-step') === '3';
    e.min = '1';
    e.step = '1';
    e.setAttribute('data-qty-step', '1');
    if (leavingPack) e.value = '1';
  }
};
function qoQtyHtml(id) {
  return '<div class="cart-qty-control">' +
    '<button type="button" onclick="qoQtyNudge(' + id + ',-1)" aria-label="Decrease">\u2212</button>' +
    '<input type="number" class="qty-val" id="qo-qty-' + id + '" value="1" min="1" step="1" data-qty-step="1" aria-label="Quantity">' +
    '<button type="button" onclick="qoQtyNudge(' + id + ',1)" aria-label="Increase">+</button>' +
  '</div>';
}
window.addQuickOrderRow = function(form) {
  form = form || 'pointe';
  rowCounter++;
  const id = rowCounter;
  const tbody = document.getElementById('qo-rows-' + form);
  if (!tbody) return;
  const tr = document.createElement('tr');
  tr.dataset.row = String(id);
  tr.dataset.qoForm = form;
  var priceQty =
    '<td class="qo-price-cell qo-col-price"><span class="qo-price" id="qo-price-' + id + '">\u2014</span></td>' +
    '<td class="qo-col-qty">' + qoQtyHtml(id) + '</td>';

  if (form === 'pointe') {
    tr.innerHTML =
      '<td><div class="qo-config-cell" id="qo-config-' + id + '">' +
        '<span class="qo-config-badge" id="qo-badge-' + id + '">Not configured</span>' +
        '<button type="button" class="btn btn-outline btn-sm" onclick="openPointeModal(' + id + ')">Configure</button>' +
      '</div></td>' +
      priceQty +
      '<td class="qo-col-action"><button type="button" class="btn btn-primary btn-sm" onclick="addPointeToCart(' + id + ')">Add</button></td>';
    tbody.appendChild(tr);
  } else if (form === 'liberty') {
    tr.innerHTML =
      '<td><div class="qo-config-cell" id="qo-config-' + id + '">' +
        '<span class="qo-config-badge" style="color:var(--charcoal-muted)">Loading\u2026</span>' +
      '</div></td>' +
      priceQty +
      '<td class="qo-col-action"><button class="btn btn-primary btn-sm" disabled>Add</button></td>';
    tbody.appendChild(tr);
    window.handleCategoryChange('liberty', id);
  } else if (form === 'merchandising') {
    tr.innerHTML =
      '<td><div class="qo-config-cell" id="qo-config-' + id + '">' +
        '<span class="qo-config-badge" style="color:var(--charcoal-muted)">Loading\u2026</span>' +
      '</div></td>' +
      priceQty +
      '<td class="qo-col-action"><button class="btn btn-primary btn-sm" disabled>Add</button></td>';
    tbody.appendChild(tr);
    window.handleCategoryChange('merchandising', id);
  } else {
    var opts = '';
    if (form === 'clothing') {
      opts =
        '<option value="leotards">Leotards</option>' +
        '<option value="tights">Tights</option>' +
        '<option value="warmers">Warmers</option>' +
        '<option value="tutus-skirts">Tutus &amp; Skirts</option>';
    } else {
      opts =
        '<option value="pointe-essentials">Pointe Essentials</option>' +
        '<option value="go-beyond-the-barre">Go Beyond The Barre</option>' +
        '<option value="dance-bags">Dance Bags</option>' +
        '<option value="jewelry">Jewelry</option>';
    }
    tr.innerHTML =
      '<td><select class="qo-select" id="qo-cat-' + id + '" aria-label="Category" onchange="handleCategoryChange(this,' + id + ')">' + opts + '</select></td>' +
      '<td><div class="qo-config-cell" id="qo-config-' + id + '">' +
        '<span class="qo-config-badge" style="color:var(--charcoal-muted)">Loading\u2026</span>' +
      '</div></td>' +
      priceQty +
      '<td class="qo-col-action"><button class="btn btn-primary btn-sm" disabled>Add</button></td>';
    tbody.appendChild(tr);
    var sel = document.getElementById('qo-cat-' + id);
    if (sel) window.handleCategoryChange(sel, id);
  }
  tr.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
};

// ── POINTE ORDER FORM: TAB SWITCHING ─────────────────────────────
window.switchTab = function(model, btn) {
  document.querySelectorAll('.model-nav-tab').forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });
  document.querySelectorAll('[id^="panel-"]').forEach(p => p.style.display = 'none');
  if (btn) { btn.classList.add('active'); btn.setAttribute('aria-selected', 'true'); }
  const panel = document.getElementById(`panel-${model}`);
  if (panel) panel.style.display = '';
};

// ── POINTE ORDER FORM: ADD TAB TO CART ───────────────────────────
window.addTabToOrder = async function(model, btnEl) {
  const api = window.GM_LONG_POINTE;
  const tbody = document.getElementById(`rows-${model}`);
  if (!tbody) return;

  const rows = tbody.querySelectorAll('tr');
  let addedCount = 0;

  for (const tr of rows) {
    const qty = parseInt(tr.querySelector('.ft-qty')?.value, 10) || 1;
    const sku = (tr.dataset.sku || tr.querySelector('.ft-sku')?.textContent || '').trim();
    const isComplete = sku && sku !== '—' && sku !== 'Loading…' && sku.indexOf('…') === -1;
    if (!isComplete) continue;
    if (!api || !api.skuAllowedByChart(sku)) {
      alert('That combination is not available: ' + sku);
      continue;
    }
    const variantId = api.getVariantId(sku);
    if (!variantId || isNaN(variantId)) {
      alert('Configuration not found for SKU: ' + sku);
      continue;
    }
    const properties = { '_sku': sku };
    try {
      await addToCart(variantId, qty, properties);
      addedCount++;
    } catch (e) {
      console.warn('Add to cart failed:', e);
      alert(e.message || 'Could not add to cart');
    }
  }

  if (addedCount === 0) {
    alert('Please complete at least one makeable row before adding to order.');
    return;
  }

  await fetchCart();
  renderCartDrawer();
  openCart();

  if (btnEl) {
    const orig = btnEl.innerHTML;
    btnEl.innerHTML = `✓ ${addedCount} row${addedCount !== 1 ? 's' : ''} added`;
    btnEl.style.background = 'var(--green)';
    setTimeout(() => { btnEl.innerHTML = orig; btnEl.style.background = ''; }, 1500);
  }
};

